import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE = "/api";

function Greetings() {
  const [greetings, setGreetings] = useState([]);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    loadGreetings();
  }, []);

  const loadGreetings = async () => {
    try {
      const res = await axios.get(`${API_BASE}/greetings`);
      setGreetings(res.data);
    } catch (error) {
      console.error("Error loading greetings:", error);
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const formData = new FormData();
    formData.append("video", file);

    try {
      await axios.post(`${API_BASE}/greetings`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("Greeting uploaded successfully!");
      loadGreetings();
    } catch (error) {
      console.error("Error uploading:", error);
      alert("Error uploading: " + (error.response?.data?.message || error.message));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  const handleDelete = async (file) => {
    if (!window.confirm("Delete this greeting?")) return;

    try {
      await axios.delete(`${API_BASE}/greetings`, { data: { file } });
      alert("Greeting deleted!");
      loadGreetings();
    } catch (error) {
      console.error("Error deleting:", error);
      alert("Error deleting: " + (error.response?.data?.message || error.message));
    }
  };

  const handleSetDefault = async (file) => {
    if (!window.confirm("Set this as the default greeting?")) return;

    try {
      await axios.post(`${API_BASE}/greetings/set-default`, { file });
      alert("Default greeting set!");
      loadGreetings(); // Reload to show updated status
    } catch (error) {
      console.error("Error setting default:", error);
      alert("Error: " + (error.response?.data?.message || error.message));
    }
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleString();
  };

  return (
    <div className="management-page">
      <h1>Manage Greetings</h1>
      
      <div className="upload-section">
        <label className="upload-btn">
          {uploading ? "Uploading..." : "📤 Upload New Greeting"}
          <input 
            type="file" 
            accept="video/*" 
            onChange={handleUpload} 
            disabled={uploading}
            style={{display: "none"}}
          />
        </label>
      </div>

      <div className="file-list">
        {greetings.length === 0 ? (
          <p>No greetings uploaded yet.</p>
        ) : (
          greetings.map((greeting) => {
            const isDefault = greeting.name === 'default.mp4' || greeting.file === 'greetings/default.mp4';
            return (
              <div key={greeting.file} className="file-item">
                <div className="file-info">
                  <video src={greeting.url} controls width="200" crossOrigin="anonymous" />
                  <div className="file-details">
                    <strong>{greeting.name}</strong>
                    {isDefault && <span className="badge">✓ Default</span>}
                    <div className="file-meta">
                      {formatBytes(greeting.size)} • {formatDate(greeting.modified)}
                    </div>
                  </div>
                </div>
                <div className="file-actions">
                  {!isDefault && (
                    <button onClick={() => handleSetDefault(greeting.file)}>⭐ Set as Default</button>
                  )}
                  {!isDefault && (
                    <button onClick={() => handleDelete(greeting.file)} className="danger">🗑 Delete</button>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default Greetings;
